/**
 * @generated SignedSource<<c11b7f51a6d9d2484989d7fe25a79788>>
 * @relayHash 4b69872138c496a0dbc03e2509a3ba62
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4b69872138c496a0dbc03e2509a3ba62

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useTimelineItemsBackQuery$variables = {
  count: number;
  cursor?: string | null | undefined;
  id: string;
};
export type useTimelineItemsBackQuery$data = {
  readonly node: {
    readonly backTimelineItems?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __id: string;
          readonly " $fragmentSpreads": FragmentRefs<"IssueTimelineItem">;
        } | null | undefined;
      } | null | undefined> | null | undefined;
      readonly pageInfo: {
        readonly startCursor: string | null | undefined;
      };
      readonly totalCount: number;
    };
  } | null | undefined;
};
export type useTimelineItemsBackQuery = {
  response: useTimelineItemsBackQuery$data;
  variables: useTimelineItemsBackQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "count"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cursor"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "before",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "last",
    "variableName": "count"
  },
  {
    "kind": "Literal",
    "name": "visibleEventsOnly",
    "value": true
  }
],
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startCursor",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": 64
    }
  ],
  "kind": "ScalarField",
  "name": "avatarUrl",
  "storageKey": "avatarUrl(size:64)"
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "login",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profileResourcePath",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCopilot",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAgent",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v17 = {
  "kind": "InlineFragment",
  "selections": [
    (v14/*: any*/),
    (v15/*: any*/),
    (v16/*: any*/)
  ],
  "type": "Bot",
  "abstractKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v19 = [
  (v18/*: any*/)
],
v20 = {
  "kind": "InlineFragment",
  "selections": (v19/*: any*/),
  "type": "User",
  "abstractKey": null
},
v21 = {
  "kind": "InlineFragment",
  "selections": (v19/*: any*/),
  "type": "EnterpriseUserAccount",
  "abstractKey": null
},
v22 = {
  "kind": "InlineFragment",
  "selections": (v19/*: any*/),
  "type": "Mannequin",
  "abstractKey": null
},
v23 = {
  "kind": "InlineFragment",
  "selections": [
    (v8/*: any*/),
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "actor",
      "plural": false,
      "selections": [
        (v10/*: any*/),
        (v11/*: any*/),
        (v12/*: any*/),
        (v13/*: any*/),
        (v7/*: any*/),
        (v17/*: any*/),
        (v20/*: any*/),
        (v21/*: any*/),
        (v22/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "TimelineEvent",
  "abstractKey": "__isTimelineEvent"
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerDidAuthor",
  "storageKey": null
},
v25 = [
  (v12/*: any*/)
],
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "avatarUrl",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profileUrl",
  "storageKey": null
},
v28 = [
  (v7/*: any*/)
],
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "willCloseTarget",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "referencedAt",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "titleHTML",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stateReason",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivate",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v25/*: any*/),
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    (v18/*: any*/),
    (v35/*: any*/),
    (v36/*: any*/)
  ],
  "storageKey": null
},
v38 = {
  "alias": "pullTitleHTML",
  "args": null,
  "kind": "ScalarField",
  "name": "titleHTML",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDraft",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isInMergeQueue",
  "storageKey": null
},
v42 = [
  (v7/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v10/*: any*/),
      (v31/*: any*/),
      (v32/*: any*/),
      (v33/*: any*/),
      (v34/*: any*/),
      (v37/*: any*/)
    ],
    "type": "Issue",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v10/*: any*/),
      (v38/*: any*/),
      (v32/*: any*/),
      (v33/*: any*/),
      (v39/*: any*/),
      (v40/*: any*/),
      (v41/*: any*/),
      (v37/*: any*/)
    ],
    "type": "PullRequest",
    "abstractKey": null
  }
],
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "concreteType": "Label",
  "kind": "LinkedField",
  "name": "label",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nameHTML",
      "storageKey": null
    },
    (v18/*: any*/),
    (v43/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueUpdateIntent",
  "kind": "LinkedField",
  "name": "intent",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rationale",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v46 = {
  "kind": "InlineFragment",
  "selections": [
    (v44/*: any*/),
    (v10/*: any*/),
    (v45/*: any*/)
  ],
  "type": "LabeledEvent",
  "abstractKey": null
},
v47 = {
  "kind": "InlineFragment",
  "selections": [
    (v44/*: any*/),
    (v10/*: any*/)
  ],
  "type": "UnlabeledEvent",
  "abstractKey": null
},
v48 = {
  "kind": "InlineFragment",
  "selections": (v25/*: any*/),
  "type": "Actor",
  "abstractKey": "__isActor"
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "resourcePath",
  "storageKey": null
},
v50 = [
  (v10/*: any*/),
  (v7/*: any*/),
  (v12/*: any*/),
  (v49/*: any*/),
  (v18/*: any*/)
],
v51 = [
  (v10/*: any*/),
  (v12/*: any*/),
  (v49/*: any*/),
  (v18/*: any*/)
],
v52 = {
  "kind": "InlineFragment",
  "selections": (v51/*: any*/),
  "type": "User",
  "abstractKey": null
},
v53 = {
  "kind": "InlineFragment",
  "selections": [
    (v10/*: any*/),
    (v12/*: any*/),
    (v49/*: any*/),
    (v14/*: any*/),
    (v16/*: any*/),
    (v15/*: any*/)
  ],
  "type": "Bot",
  "abstractKey": null
},
v54 = {
  "kind": "InlineFragment",
  "selections": (v51/*: any*/),
  "type": "Mannequin",
  "abstractKey": null
},
v55 = {
  "kind": "InlineFragment",
  "selections": [
    (v10/*: any*/),
    (v12/*: any*/),
    (v49/*: any*/)
  ],
  "type": "Organization",
  "abstractKey": null
},
v56 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "milestoneTitle",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Milestone",
    "kind": "LinkedField",
    "name": "milestone",
    "plural": false,
    "selections": [
      (v10/*: any*/),
      (v32/*: any*/)
    ],
    "storageKey": null
  }
],
v57 = {
  "kind": "InlineFragment",
  "selections": (v56/*: any*/),
  "type": "MilestonedEvent",
  "abstractKey": null
},
v58 = {
  "kind": "InlineFragment",
  "selections": (v56/*: any*/),
  "type": "DemilestonedEvent",
  "abstractKey": null
},
v59 = [
  (v18/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "dataType",
    "storageKey": null
  }
],
v60 = {
  "kind": "InlineFragment",
  "selections": (v59/*: any*/),
  "type": "IssueFieldText",
  "abstractKey": null
},
v61 = {
  "kind": "InlineFragment",
  "selections": (v59/*: any*/),
  "type": "IssueFieldDate",
  "abstractKey": null
},
v62 = {
  "kind": "InlineFragment",
  "selections": (v59/*: any*/),
  "type": "IssueFieldNumber",
  "abstractKey": null
},
v63 = {
  "kind": "InlineFragment",
  "selections": (v59/*: any*/),
  "type": "IssueFieldSingleSelect",
  "abstractKey": null
},
v64 = {
  "kind": "InlineFragment",
  "selections": (v59/*: any*/),
  "type": "IssueFieldMultiSelect",
  "abstractKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "issueField",
  "plural": false,
  "selections": [
    (v60/*: any*/),
    (v61/*: any*/),
    (v62/*: any*/),
    (v63/*: any*/),
    (v64/*: any*/)
  ],
  "storageKey": null
},
v66 = [
  (v18/*: any*/),
  (v43/*: any*/)
],
v67 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueFieldTimelineOption",
  "kind": "LinkedField",
  "name": "options",
  "plural": true,
  "selections": (v66/*: any*/),
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "newColor",
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueFieldTimelineOption",
  "kind": "LinkedField",
  "name": "newOptions",
  "plural": true,
  "selections": (v66/*: any*/),
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "newValue",
  "storageKey": null
},
v72 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "IssueComment",
    "kind": "LinkedField",
    "name": "issueComment",
    "plural": false,
    "selections": [
      (v10/*: any*/),
      (v32/*: any*/),
      (v8/*: any*/)
    ],
    "storageKey": null
  }
],
v73 = {
  "kind": "InlineFragment",
  "selections": (v72/*: any*/),
  "type": "IssueCommentPinnedEvent",
  "abstractKey": null
},
v74 = {
  "kind": "InlineFragment",
  "selections": (v72/*: any*/),
  "type": "IssueCommentUnpinnedEvent",
  "abstractKey": null
},
v75 = [
  (v10/*: any*/)
],
v76 = {
  "kind": "InlineFragment",
  "selections": (v75/*: any*/),
  "type": "SubscribedEvent",
  "abstractKey": null
},
v77 = {
  "kind": "InlineFragment",
  "selections": (v75/*: any*/),
  "type": "UnsubscribedEvent",
  "abstractKey": null
},
v78 = {
  "kind": "InlineFragment",
  "selections": (v75/*: any*/),
  "type": "MentionedEvent",
  "abstractKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "closingProjectItemStatus",
  "storageKey": null
},
v80 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v81 = {
  "kind": "InlineFragment",
  "selections": [
    (v32/*: any*/),
    (v80/*: any*/)
  ],
  "type": "ProjectV2",
  "abstractKey": null
},
v82 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "abbreviatedOid",
  "storageKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v18/*: any*/),
    (v36/*: any*/)
  ],
  "storageKey": null
},
v84 = {
  "kind": "InlineFragment",
  "selections": (v75/*: any*/),
  "type": "ReopenedEvent",
  "abstractKey": null
},
v85 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lockReason",
      "storageKey": null
    },
    (v10/*: any*/)
  ],
  "type": "LockedEvent",
  "abstractKey": null
},
v86 = {
  "kind": "InlineFragment",
  "selections": (v75/*: any*/),
  "type": "UnlockedEvent",
  "abstractKey": null
},
v87 = {
  "kind": "InlineFragment",
  "selections": (v75/*: any*/),
  "type": "PinnedEvent",
  "abstractKey": null
},
v88 = {
  "kind": "InlineFragment",
  "selections": (v75/*: any*/),
  "type": "UnpinnedEvent",
  "abstractKey": null
},
v89 = {
  "kind": "InlineFragment",
  "selections": [
    (v10/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "previousTitle",
      "storageKey": null
    }
  ],
  "type": "RenamedTitleEvent",
  "abstractKey": null
},
v90 = [
  (v7/*: any*/),
  (v10/*: any*/),
  (v31/*: any*/),
  (v32/*: any*/),
  (v33/*: any*/),
  (v34/*: any*/),
  (v37/*: any*/)
],
v91 = {
  "alias": null,
  "args": null,
  "concreteType": "Issue",
  "kind": "LinkedField",
  "name": "blockingIssue",
  "plural": false,
  "selections": (v90/*: any*/),
  "storageKey": null
},
v92 = [
  (v10/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "blockedIssue",
    "plural": false,
    "selections": (v90/*: any*/),
    "storageKey": null
  }
],
v93 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "blockDuration",
  "storageKey": null
},
v94 = [
  (v7/*: any*/),
  (v10/*: any*/),
  (v31/*: any*/),
  (v32/*: any*/),
  (v33/*: any*/),
  (v34/*: any*/),
  (v37/*: any*/),
  (v8/*: any*/)
],
v95 = [
  (v10/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "subIssue",
    "plural": false,
    "selections": (v94/*: any*/),
    "storageKey": null
  }
],
v96 = [
  (v10/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "parent",
    "plural": false,
    "selections": (v94/*: any*/),
    "storageKey": null
  }
],
v97 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "willCloseSubject",
  "storageKey": null
},
v98 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v99 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "messageHeadlineHTML",
  "storageKey": null
},
v100 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "messageBodyHTML",
  "storageKey": null
},
v101 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "defaultBranch",
  "storageKey": null
},
v102 = [
  (v10/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "subject",
    "plural": false,
    "selections": [
      (v7/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v80/*: any*/),
          (v32/*: any*/),
          (v33/*: any*/),
          (v39/*: any*/),
          (v40/*: any*/),
          (v41/*: any*/),
          (v83/*: any*/)
        ],
        "type": "PullRequest",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
],
v103 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nameWithOwner",
  "storageKey": null
},
v104 = {
  "alias": null,
  "args": null,
  "concreteType": "ProjectV2",
  "kind": "LinkedField",
  "name": "project",
  "plural": false,
  "selections": [
    (v80/*: any*/),
    (v32/*: any*/)
  ],
  "storageKey": null
},
v105 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "previousStatus",
  "storageKey": null
},
v106 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v107 = {
  "kind": "InlineFragment",
  "selections": (v75/*: any*/),
  "type": "ConvertedFromDraftEvent",
  "abstractKey": null
},
v108 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueType",
  "kind": "LinkedField",
  "name": "issueType",
  "plural": false,
  "selections": (v66/*: any*/),
  "storageKey": null
},
v109 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
},
v110 = [
  (v7/*: any*/),
  (v12/*: any*/),
  (v10/*: any*/)
],
v111 = {
  "kind": "InlineFragment",
  "selections": (v75/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v112 = [
  (v7/*: any*/),
  (v111/*: any*/)
],
v113 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v110/*: any*/),
  "storageKey": null
},
v114 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    (v18/*: any*/),
    (v35/*: any*/),
    (v113/*: any*/)
  ],
  "storageKey": null
},
v115 = [
  (v7/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v10/*: any*/),
      (v31/*: any*/),
      (v32/*: any*/),
      (v33/*: any*/),
      (v34/*: any*/),
      (v114/*: any*/)
    ],
    "type": "Issue",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v10/*: any*/),
      (v38/*: any*/),
      (v32/*: any*/),
      (v33/*: any*/),
      (v39/*: any*/),
      (v40/*: any*/),
      (v41/*: any*/),
      (v114/*: any*/)
    ],
    "type": "PullRequest",
    "abstractKey": null
  },
  (v111/*: any*/)
],
v116 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "issueField",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    (v60/*: any*/),
    (v61/*: any*/),
    (v62/*: any*/),
    (v63/*: any*/),
    (v64/*: any*/),
    (v111/*: any*/)
  ],
  "storageKey": null
},
v117 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v18/*: any*/),
    (v113/*: any*/),
    (v10/*: any*/)
  ],
  "storageKey": null
},
v118 = [
  (v7/*: any*/),
  (v10/*: any*/),
  (v31/*: any*/),
  (v32/*: any*/),
  (v33/*: any*/),
  (v34/*: any*/),
  (v114/*: any*/)
],
v119 = {
  "alias": null,
  "args": null,
  "concreteType": "Issue",
  "kind": "LinkedField",
  "name": "blockingIssue",
  "plural": false,
  "selections": (v118/*: any*/),
  "storageKey": null
},
v120 = [
  (v10/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "blockedIssue",
    "plural": false,
    "selections": (v118/*: any*/),
    "storageKey": null
  }
],
v121 = [
  (v7/*: any*/),
  (v10/*: any*/),
  (v31/*: any*/),
  (v32/*: any*/),
  (v33/*: any*/),
  (v34/*: any*/),
  (v114/*: any*/),
  (v8/*: any*/)
],
v122 = [
  (v10/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "subIssue",
    "plural": false,
    "selections": (v121/*: any*/),
    "storageKey": null
  }
],
v123 = [
  (v10/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "parent",
    "plural": false,
    "selections": (v121/*: any*/),
    "storageKey": null
  }
],
v124 = [
  (v10/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "subject",
    "plural": false,
    "selections": [
      (v7/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v80/*: any*/),
          (v32/*: any*/),
          (v33/*: any*/),
          (v39/*: any*/),
          (v40/*: any*/),
          (v41/*: any*/),
          (v117/*: any*/)
        ],
        "type": "PullRequest",
        "abstractKey": null
      },
      (v111/*: any*/)
    ],
    "storageKey": null
  }
],
v125 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "actor",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    (v12/*: any*/),
    (v13/*: any*/),
    (v7/*: any*/),
    (v17/*: any*/),
    (v20/*: any*/),
    (v21/*: any*/),
    (v22/*: any*/),
    (v10/*: any*/)
  ],
  "storageKey": null
},
v126 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "canonical",
  "plural": false,
  "selections": (v115/*: any*/),
  "storageKey": null
},
v127 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCanonicalOfClosedDuplicate",
  "storageKey": null
},
v128 = {
  "alias": null,
  "args": null,
  "concreteType": "ProjectV2",
  "kind": "LinkedField",
  "name": "project",
  "plural": false,
  "selections": [
    (v80/*: any*/),
    (v32/*: any*/),
    (v10/*: any*/)
  ],
  "storageKey": null
},
v129 = [
  (v18/*: any*/),
  (v43/*: any*/),
  (v10/*: any*/)
],
v130 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueType",
  "kind": "LinkedField",
  "name": "issueType",
  "plural": false,
  "selections": (v129/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useTimelineItemsBackQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": "backTimelineItems",
                "args": (v4/*: any*/),
                "concreteType": "IssueTimelineItemsConnection",
                "kind": "LinkedField",
                "name": "timelineItems",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IssueTimelineItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "IssueTimelineItem",
                            "selections": [
                              (v7/*: any*/),
                              (v23/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v8/*: any*/),
                                  (v24/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Issue",
                                    "kind": "LinkedField",
                                    "name": "issue",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "author",
                                        "plural": false,
                                        "selections": (v25/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                      (v12/*: any*/),
                                      (v26/*: any*/),
                                      (v27/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "IssueComment",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "source",
                                    "plural": false,
                                    "selections": (v28/*: any*/),
                                    "storageKey": null
                                  },
                                  (v29/*: any*/),
                                  (v30/*: any*/),
                                  (v8/*: any*/),
                                  {
                                    "alias": "innerSource",
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "source",
                                    "plural": false,
                                    "selections": (v42/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "type": "CrossReferencedEvent",
                                "abstractKey": null
                              },
                              (v46/*: any*/),
                              (v47/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v10/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "assignee",
                                    "plural": false,
                                    "selections": [
                                      (v48/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v50/*: any*/),
                                        "type": "User",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v50/*: any*/),
                                        "type": "Mannequin",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v10/*: any*/),
                                          (v7/*: any*/),
                                          (v12/*: any*/),
                                          (v49/*: any*/)
                                        ],
                                        "type": "Organization",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v10/*: any*/),
                                          (v7/*: any*/),
                                          (v12/*: any*/),
                                          (v49/*: any*/),
                                          (v14/*: any*/),
                                          (v16/*: any*/),
                                          (v15/*: any*/)
                                        ],
                                        "type": "Bot",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v45/*: any*/)
                                ],
                                "type": "AssignedEvent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "assignee",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v52/*: any*/),
                                      (v53/*: any*/),
                                      (v54/*: any*/),
                                      (v55/*: any*/),
                                      (v48/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v10/*: any*/)
                                ],
                                "type": "UnassignedEvent",
                                "abstractKey": null
                              },
                              (v57/*: any*/),
                              (v58/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v65/*: any*/),
                                  (v67/*: any*/),
                                  (v68/*: any*/),
                                  (v43/*: any*/),
                                  (v45/*: any*/)
                                ],
                                "type": "IssueFieldAddedEvent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v65/*: any*/),
                                  (v69/*: any*/),
                                  (v70/*: any*/),
                                  (v71/*: any*/),
                                  (v45/*: any*/)
                                ],
                                "type": "IssueFieldChangedEvent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v65/*: any*/),
                                  (v45/*: any*/)
                                ],
                                "type": "IssueFieldRemovedEvent",
                                "abstractKey": null
                              },
                              (v73/*: any*/),
                              (v74/*: any*/),
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "IssueComment_issueComment"
                              },
                              (v76/*: any*/),
                              (v77/*: any*/),
                              (v78/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v8/*: any*/),
                                  (v9/*: any*/),
                                  (v34/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "duplicateOf",
                                    "plural": false,
                                    "selections": (v42/*: any*/),
                                    "storageKey": null
                                  },
                                  (v79/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "closer",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v81/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v32/*: any*/),
                                          (v33/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Repository",
                                            "kind": "LinkedField",
                                            "name": "repository",
                                            "plural": false,
                                            "selections": [
                                              (v10/*: any*/),
                                              (v18/*: any*/),
                                              (v36/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "PullRequest",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v32/*: any*/),
                                          (v82/*: any*/),
                                          (v83/*: any*/)
                                        ],
                                        "type": "Commit",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v10/*: any*/),
                                  (v45/*: any*/)
                                ],
                                "type": "ClosedEvent",
                                "abstractKey": null
                              },
                              (v84/*: any*/),
                              (v85/*: any*/),
                              (v86/*: any*/),
                              (v87/*: any*/),
                              (v88/*: any*/),
                              (v89/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v10/*: any*/),
                                  (v91/*: any*/)
                                ],
                                "type": "BlockedByAddedEvent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v8/*: any*/),
                                  (v10/*: any*/),
                                  (v9/*: any*/),
                                  (v91/*: any*/)
                                ],
                                "type": "BlockedByRemovedEvent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v92/*: any*/),
                                "type": "BlockingAddedEvent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v92/*: any*/),
                                "type": "BlockingRemovedEvent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v10/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "deletedCommentAuthor",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v12/*: any*/),
                                      (v20/*: any*/),
                                      (v22/*: any*/),
                                      (v21/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "CommentDeletedEvent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v93/*: any*/),
                                  (v10/*: any*/),
                                  {
                                    "alias": "blockedUser",
                                    "args": null,
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "subject",
                                    "plural": false,
                                    "selections": [
                                      (v12/*: any*/),
                                      (v18/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "UserBlockedEvent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v95/*: any*/),
                                "type": "SubIssueAddedEvent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v95/*: any*/),
                                "type": "SubIssueRemovedEvent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v96/*: any*/),
                                "type": "ParentIssueAddedEvent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v96/*: any*/),
                                "type": "ParentIssueRemovedEvent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v97/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "subject",
                                    "plural": false,
                                    "selections": (v28/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Commit",
                                    "kind": "LinkedField",
                                    "name": "commit",
                                    "plural": false,
                                    "selections": [
                                      (v98/*: any*/),
                                      (v99/*: any*/),
                                      (v100/*: any*/),
                                      (v32/*: any*/),
                                      (v82/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Repository",
                                        "kind": "LinkedField",
                                        "name": "repository",
                                        "plural": false,
                                        "selections": [
                                          (v18/*: any*/),
                                          (v36/*: any*/),
                                          (v101/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "ReferencedEvent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v102/*: any*/),
                                "type": "ConnectedEvent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v10/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Repository",
                                    "kind": "LinkedField",
                                    "name": "fromRepository",
                                    "plural": false,
                                    "selections": [
                                      (v103/*: any*/),
                                      (v32/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "TransferredEvent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v102/*: any*/),
                                "type": "DisconnectedEvent",
                                "abstractKey": null
                              },
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "MarkedAsDuplicateEvent"
                              },
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "UnmarkedAsDuplicateEvent"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v10/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Discussion",
                                    "kind": "LinkedField",
                                    "name": "discussion",
                                    "plural": false,
                                    "selections": [
                                      (v32/*: any*/),
                                      (v33/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "ConvertedToDiscussionEvent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v8/*: any*/),
                                  (v9/*: any*/),
                                  (v104/*: any*/)
                                ],
                                "type": "AddedToProjectV2Event",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v10/*: any*/),
                                  (v104/*: any*/)
                                ],
                                "type": "RemovedFromProjectV2Event",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v10/*: any*/),
                                  (v104/*: any*/),
                                  (v105/*: any*/),
                                  (v106/*: any*/)
                                ],
                                "type": "ProjectV2ItemStatusChangedEvent",
                                "abstractKey": null
                              },
                              (v107/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v10/*: any*/),
                                  (v108/*: any*/),
                                  (v45/*: any*/)
                                ],
                                "type": "IssueTypeAddedEvent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v10/*: any*/),
                                  (v108/*: any*/)
                                ],
                                "type": "IssueTypeRemovedEvent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v10/*: any*/),
                                  (v108/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "IssueType",
                                    "kind": "LinkedField",
                                    "name": "prevIssueType",
                                    "plural": false,
                                    "selections": (v66/*: any*/),
                                    "storageKey": null
                                  },
                                  (v45/*: any*/)
                                ],
                                "type": "IssueTypeChangedEvent",
                                "abstractKey": null
                              },
                              (v109/*: any*/)
                            ],
                            "args": null,
                            "argumentDefinitions": []
                          },
                          (v109/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Issue",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "useTimelineItemsBackQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v10/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": "backTimelineItems",
                "args": (v4/*: any*/),
                "concreteType": "IssueTimelineItemsConnection",
                "kind": "LinkedField",
                "name": "timelineItems",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IssueTimelineItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isIssueTimelineItems"
                          },
                          (v23/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v8/*: any*/),
                              (v24/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Issue",
                                "kind": "LinkedField",
                                "name": "issue",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": (v110/*: any*/),
                                    "storageKey": null
                                  },
                                  (v10/*: any*/),
                                  (v33/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "locked",
                                    "storageKey": null
                                  },
                                  (v8/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "author",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  (v12/*: any*/),
                                  (v26/*: any*/),
                                  (v27/*: any*/),
                                  (v10/*: any*/),
                                  (v20/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v10/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "body",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "unfurlReferences",
                                    "value": true
                                  }
                                ],
                                "kind": "ScalarField",
                                "name": "bodyHTML",
                                "storageKey": "bodyHTML(unfurlReferences:true)"
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "bodyVersion",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "viewerCanUpdate",
                                "storageKey": null
                              },
                              (v32/*: any*/),
                              (v9/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "authorAssociation",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "viewerCanDelete",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "viewerCanMinimize",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "viewerCanUnminimize",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "viewerCanReport",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "viewerCanReportToMaintainer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "viewerCanBlockFromOrg",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "viewerCanUnblockFromOrg",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "viewerCanPin",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "viewerCanUnpin",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "App",
                                "kind": "LinkedField",
                                "name": "viaApp",
                                "plural": false,
                                "selections": [
                                  (v18/*: any*/),
                                  (v32/*: any*/),
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": "isHidden",
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isMinimized",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "minimizedReason",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "showSpammyBadge",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "createdViaEmail",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Sponsorship",
                                "kind": "LinkedField",
                                "name": "authorToRepoOwnerSponsorship",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isActive",
                                    "storageKey": null
                                  },
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Repository",
                                "kind": "LinkedField",
                                "name": "repository",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  (v18/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "owner",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v10/*: any*/),
                                      (v12/*: any*/),
                                      (v32/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v35/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "viewerCanCreateIssues",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "slashCommandsEnabled",
                                    "storageKey": null
                                  },
                                  (v103/*: any*/),
                                  (v8/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "viewerCanReadUserContentEdits",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "lastEditedAt",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UserContentEdit",
                                "kind": "LinkedField",
                                "name": "lastUserContentEdit",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "editor",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v32/*: any*/),
                                      (v12/*: any*/),
                                      (v10/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "pinnedBy",
                                "plural": false,
                                "selections": [
                                  (v12/*: any*/),
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "kind": "ClientExtension",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "pendingMinimizeReason",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "pendingBlock",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "pendingUnblock",
                                    "storageKey": null
                                  }
                                ]
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ReactionGroup",
                                    "kind": "LinkedField",
                                    "name": "reactionGroups",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "content",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "viewerHasReacted",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": [
                                          {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 5
                                          }
                                        ],
                                        "concreteType": "ReactorConnection",
                                        "kind": "LinkedField",
                                        "name": "reactors",
                                        "plural": false,
                                        "selections": [
                                          (v6/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                              (v7/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": (v25/*: any*/),
                                                "type": "User",
                                                "abstractKey": null
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v12/*: any*/),
                                                  (v14/*: any*/),
                                                  (v15/*: any*/),
                                                  (v16/*: any*/)
                                                ],
                                                "type": "Bot",
                                                "abstractKey": null
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": (v25/*: any*/),
                                                "type": "Organization",
                                                "abstractKey": null
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": (v25/*: any*/),
                                                "type": "Mannequin",
                                                "abstractKey": null
                                              },
                                              (v111/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": "reactors(first:5)"
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "Reactable",
                                "abstractKey": "__isReactable"
                              }
                            ],
                            "type": "IssueComment",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "source",
                                "plural": false,
                                "selections": (v112/*: any*/),
                                "storageKey": null
                              },
                              (v29/*: any*/),
                              (v30/*: any*/),
                              (v8/*: any*/),
                              {
                                "alias": "innerSource",
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "source",
                                "plural": false,
                                "selections": (v115/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "CrossReferencedEvent",
                            "abstractKey": null
                          },
                          (v46/*: any*/),
                          (v47/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "assignee",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  (v48/*: any*/),
                                  (v52/*: any*/),
                                  (v54/*: any*/),
                                  (v55/*: any*/),
                                  (v53/*: any*/),
                                  (v111/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v45/*: any*/)
                            ],
                            "type": "AssignedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "assignee",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  (v52/*: any*/),
                                  (v53/*: any*/),
                                  (v54/*: any*/),
                                  (v55/*: any*/),
                                  (v111/*: any*/),
                                  (v48/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v10/*: any*/)
                            ],
                            "type": "UnassignedEvent",
                            "abstractKey": null
                          },
                          (v57/*: any*/),
                          (v58/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v116/*: any*/),
                              (v67/*: any*/),
                              (v68/*: any*/),
                              (v43/*: any*/),
                              (v45/*: any*/)
                            ],
                            "type": "IssueFieldAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v116/*: any*/),
                              (v69/*: any*/),
                              (v70/*: any*/),
                              (v71/*: any*/),
                              (v45/*: any*/)
                            ],
                            "type": "IssueFieldChangedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v116/*: any*/),
                              (v45/*: any*/)
                            ],
                            "type": "IssueFieldRemovedEvent",
                            "abstractKey": null
                          },
                          (v73/*: any*/),
                          (v74/*: any*/),
                          (v76/*: any*/),
                          (v77/*: any*/),
                          (v78/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v8/*: any*/),
                              (v9/*: any*/),
                              (v34/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "duplicateOf",
                                "plural": false,
                                "selections": (v115/*: any*/),
                                "storageKey": null
                              },
                              (v79/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "closer",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  (v81/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v32/*: any*/),
                                      (v33/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Repository",
                                        "kind": "LinkedField",
                                        "name": "repository",
                                        "plural": false,
                                        "selections": [
                                          (v10/*: any*/),
                                          (v18/*: any*/),
                                          (v113/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "PullRequest",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v32/*: any*/),
                                      (v82/*: any*/),
                                      (v117/*: any*/)
                                    ],
                                    "type": "Commit",
                                    "abstractKey": null
                                  },
                                  (v111/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v10/*: any*/),
                              (v45/*: any*/)
                            ],
                            "type": "ClosedEvent",
                            "abstractKey": null
                          },
                          (v84/*: any*/),
                          (v85/*: any*/),
                          (v86/*: any*/),
                          (v87/*: any*/),
                          (v88/*: any*/),
                          (v89/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              (v119/*: any*/)
                            ],
                            "type": "BlockedByAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v8/*: any*/),
                              (v10/*: any*/),
                              (v9/*: any*/),
                              (v119/*: any*/)
                            ],
                            "type": "BlockedByRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v120/*: any*/),
                            "type": "BlockingAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v120/*: any*/),
                            "type": "BlockingRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "deletedCommentAuthor",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  (v12/*: any*/),
                                  (v20/*: any*/),
                                  (v22/*: any*/),
                                  (v21/*: any*/),
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "CommentDeletedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v93/*: any*/),
                              (v10/*: any*/),
                              {
                                "alias": "blockedUser",
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "subject",
                                "plural": false,
                                "selections": [
                                  (v12/*: any*/),
                                  (v18/*: any*/),
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "UserBlockedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v122/*: any*/),
                            "type": "SubIssueAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v122/*: any*/),
                            "type": "SubIssueRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v123/*: any*/),
                            "type": "ParentIssueAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v123/*: any*/),
                            "type": "ParentIssueRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v97/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "subject",
                                "plural": false,
                                "selections": (v112/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Commit",
                                "kind": "LinkedField",
                                "name": "commit",
                                "plural": false,
                                "selections": [
                                  (v98/*: any*/),
                                  (v99/*: any*/),
                                  (v100/*: any*/),
                                  (v32/*: any*/),
                                  (v82/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Repository",
                                    "kind": "LinkedField",
                                    "name": "repository",
                                    "plural": false,
                                    "selections": [
                                      (v18/*: any*/),
                                      (v113/*: any*/),
                                      (v101/*: any*/),
                                      (v10/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ReferencedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v124/*: any*/),
                            "type": "ConnectedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Repository",
                                "kind": "LinkedField",
                                "name": "fromRepository",
                                "plural": false,
                                "selections": [
                                  (v103/*: any*/),
                                  (v32/*: any*/),
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "TransferredEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v124/*: any*/),
                            "type": "DisconnectedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v125/*: any*/),
                              (v9/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "duplicate",
                                "plural": false,
                                "selections": (v115/*: any*/),
                                "storageKey": null
                              },
                              (v126/*: any*/),
                              (v127/*: any*/),
                              (v8/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "viewerCanUndo",
                                "storageKey": null
                              },
                              (v10/*: any*/),
                              {
                                "kind": "ClientExtension",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "pendingUndo",
                                    "storageKey": null
                                  }
                                ]
                              }
                            ],
                            "type": "MarkedAsDuplicateEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v125/*: any*/),
                              (v9/*: any*/),
                              (v126/*: any*/),
                              (v127/*: any*/),
                              (v8/*: any*/)
                            ],
                            "type": "UnmarkedAsDuplicateEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Discussion",
                                "kind": "LinkedField",
                                "name": "discussion",
                                "plural": false,
                                "selections": [
                                  (v32/*: any*/),
                                  (v33/*: any*/),
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ConvertedToDiscussionEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v8/*: any*/),
                              (v9/*: any*/),
                              (v128/*: any*/)
                            ],
                            "type": "AddedToProjectV2Event",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              (v128/*: any*/)
                            ],
                            "type": "RemovedFromProjectV2Event",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              (v128/*: any*/),
                              (v105/*: any*/),
                              (v106/*: any*/)
                            ],
                            "type": "ProjectV2ItemStatusChangedEvent",
                            "abstractKey": null
                          },
                          (v107/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              (v130/*: any*/),
                              (v45/*: any*/)
                            ],
                            "type": "IssueTypeAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              (v130/*: any*/)
                            ],
                            "type": "IssueTypeRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              (v130/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "IssueType",
                                "kind": "LinkedField",
                                "name": "prevIssueType",
                                "plural": false,
                                "selections": (v129/*: any*/),
                                "storageKey": null
                              },
                              (v45/*: any*/)
                            ],
                            "type": "IssueTypeChangedEvent",
                            "abstractKey": null
                          },
                          (v109/*: any*/),
                          (v111/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Issue",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "4b69872138c496a0dbc03e2509a3ba62",
    "metadata": {},
    "name": "useTimelineItemsBackQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "7bbd726e814957246241666ea2dbddd4";

export default node;
